import React, { FC, useState } from 'react';
import { useT } from '@transifex/react';
import { useRouter } from 'next/router';
import ArrowBack from '@raisin/components-lib/Icons/ArrowBack';
import messages from './messages';
import { ArchiveButtonProps } from '../types';
import * as S from '../styles';

export const ArchiveButton: FC<ArchiveButtonProps> = ({ position, url }) => {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const t = useT();

  return (
    <S.Button
      $position={position}
      size="medium"
      mode="primaryText"
      loading={loading}
      startIcon={<ArrowBack size="small" />}
      onClick={() => {
        setLoading(true);
        url ? (window.location.href = url) : router.back();
      }}
    >
      {t(messages.backToArchive)}
    </S.Button>
  );
};
